/* eslint-disable no-useless-escape */
/* eslint-disable no-unused-vars */
import * as Yup from "yup";

declare module "yup" {
  interface StringSchema {
    integer(message: string): StringSchema;
    letters(message: string): StringSchema;
    startWith0(): StringSchema;
    startWith4(): StringSchema;
    lettersWithNumbers(message: string): StringSchema;
    noCharacters(): StringSchema;
    validEmail(message: string): StringSchema;
    customerName(message: string): StringSchema;
    decimal(message: string): StringSchema;
    internationalNumber(message: string): StringSchema;
  }
}

Yup.addMethod<Yup.StringSchema>(Yup.string, "integer", function integer(message: string) {
  return this.matches(/^[1-9]\d*$/, `The ${message} entered is invalid.`);
});

Yup.addMethod<Yup.StringSchema>(Yup.string, "internationalNumber", function internationalNumber(message: string) {
  return this.matches(/^[+\d](?:.*\d)?$/, `The ${message} entered is invalid.`);
});

Yup.addMethod<Yup.StringSchema>(Yup.string, "letters", function letters(message: string) {
  return this.matches(/^[A-Za-z ]+$/, `The ${message} entered is invalid.`);
});

Yup.addMethod<Yup.StringSchema>(Yup.string, "startWith0", function startWith0() {
  return this.matches(/^0/, "The cell number entered should start with 0.");
});

Yup.addMethod<Yup.StringSchema>(Yup.string, "lettersWithNumbers", function lettersWithNumbers(message: string) {
  return this.matches(/\w$/, `The ${message} entered is invalid.`);
});

Yup.addMethod<Yup.StringSchema>(Yup.string, "noCharacters", function noCharacters() {
  return this.matches(/^[^~!@#$%^&*()_+":?><]+$/g, "Invalid, no special character allowed.");
});

Yup.addMethod<Yup.StringSchema>(Yup.string, "validEmail", function validEmail(message: string) {
  return this.matches(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    `The ${message} entered is invalid.`,
  );
});

Yup.addMethod<Yup.StringSchema>(Yup.string, "decimal", function decimal(message: string) {
  return this.matches(/^(\d{1,10}|\d{0,10}\.\d{1,2})$/, `The ${message} entered is invalid.`);
});

Yup.addMethod<Yup.StringSchema>(Yup.string, "customerName", function customerName(message: string) {
  return this.matches(/^[a-z ,.'-]+$/i, `The ${message} entered is invalid.`);
});

export const LineItemSchema = Yup.object().shape({
  itemName: Yup.string().required("Enter an item name."),
  description: Yup.string().required("Enter an item description."),
  price: Yup.string().required("Enter item price.").decimal("rand amount").noCharacters(),
  lineItemQuantity: Yup.string().required("Enter item quantity.").noCharacters().integer("quantity"),
});

const getStringValidationDependentOn = (dependency: string, fieldName: string): Yup.StringSchema => {
  return Yup.string()
    .when(`${dependency}`, {
      is: (val: string) => val?.length > 0,
      then: Yup.string().trim().required(`Please enter a valid ${fieldName}.`),
    })
    .max(60, `The ${fieldName} entered is invalid.`);
};

export const CustomerInformationFormSchema = Yup.object().shape({
  customerName: Yup.string()
    .customerName("customer name")
    .min(2, "The customer name entered is invalid.")
    .max(40, "The customer name entered is invalid.")
    .required("Please enter a customer name."),

  emailAddress: Yup.string()
    .validEmail("email")
    .min(7, "The email entered is invalid.")
    .max(50, "The email entered is invalid.")
    .required("Please enter an email."),

  billingAddress: Yup.object().shape({
    streetAddress: getStringValidationDependentOn("complexBuilding", "street address"),

    suburb: getStringValidationDependentOn("streetAddress", "suburb"),

    complexBuilding: Yup.string().max(70, "The complex/building entered is invalid."),

    province: getStringValidationDependentOn("suburb", "province"),

    city: getStringValidationDependentOn("province", "city"),

    country: getStringValidationDependentOn("city", "country"),

    postalCode: getStringValidationDependentOn("country", "postal code"),
  }),
});
